import { useMutation } from "@tanstack/react-query";
import { unitAdd, UnitAddParams } from "common/api/citajteo/dl_unit/citajteo_unit";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnitAddParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useUnitAdd = (hookParams?: UseUnitAddParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: unitAddMutate } = useMutation({
    mutationFn: async (unitAddParams: UnitAddParams) => {
      const response = await unitAdd(unitAddParams);

      if (response === null) {
        throw new Error("unitAdd failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { unitAddMutate };
};
